const Glide = window.Glide;
import { centerControlsOnImage, disableIfGlideFit, setButtonsVisibility,  } from "../../../Scripts/glideControls.js";
const sparkArticle = (function() {
    function setUpCarousel() {
      const sliderArticles = document.querySelectorAll(".block__sparkArticles .glide");
      const imageHolder = document.querySelector(".block__sparkArticles .block__imageHolder");
      const glideControls =  document.querySelectorAll(".block__sparkArticles .block__glideControls");
      const glides = [];
      const options = {
              perView: 4,
              peek: { before: 0, after: 91 },
              bound: true,
              gap: 16,
              rewind: false,
              breakpoints: {
                  649: {
                      perView: 1,
                      peek: { before: 0, after: 70 },
                      gap: 16,
                  },
                  767: {
                      perView: 1,
                      peek: { before: 0, after: 186 },
                      gap: 16,
                  },
                  1023: {
                      perView: 2,
                      peek: { before: 0, after: 156 },
                      gap: 16,
                  },
                  1365: {
                      perView: 3,
                      gap: 16,
                      peek: { before: 0, after: 150 },
                  },
              },
          };
      sliderArticles.forEach((slider) => {
      let glide = new Glide(slider, options);
      glide.on("move.after", () => {
        let firstButton = glide.selector.querySelector(".button__glide.button__prev");
        let lastButton = glide.selector.querySelector(".button__glide.button__next");
        let numOfSlides = glide.selector.querySelectorAll(".glide__slide").length;
        setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
      });
      glide.on("build.after", () => {
        centerControlsOnImage(imageHolder, glideControls);
      });
      glides.push(glide.mount());
    });
    for (let i = 0; i < glides.length; i++) {
      disableIfGlideFit(glides[i]);
    }
    window.addEventListener("resize", () => {
      for (let i = 0; i < glides.length; i++) {
        disableIfGlideFit(glides[i]);
      }
    });
    window.addEventListener("resize", () => {
      centerControlsOnImage(imageHolder, glideControls);
    });
  }
  setUpCarousel();
  return {setUpCarousel: setUpCarousel};
}
)();

// Submit the form
$('.subscribe-spark-form').on('submit', function (e) {
    e.preventDefault();
    // prevent submit button from submitting again
    let form = $(this);
    form.find('button[type="submit"]').prop('disabled', true);
    let guid = form.data('widget-guid');

    // Get the email value
    var email = document.getElementById("emailInput" + guid).value;
    var address1 = document.getElementById("address1Input" + guid).value;
    var address2 = document.getElementById("address2Input" + guid).value;
    var city = document.getElementById("cityInput" + guid).value;
    var state = document.getElementById("stateInput" + guid).value;
    var postalCode = document.getElementById("postalCodeInput" + guid).value;

    var data = {
        Email: email,
        Address1: address1,
        Address2: address2,
        City: city,
        State: state,
        PostalCode: postalCode 
    };

    $.ajax({
        url: '/SparkSubscriber/Subcribe',
        type: 'POST',
        data: data,
        success: function (response) {
            if (response) {
                $('#subscribeSparkModal' + guid).append('<p class="p__message">Thanks for signing up for Spark Magazine. Our print publication will be on its way to your mailbox soon. Please email onlinerequests@dallasmarketcenter.com for questions or concerns.</p>');
            }
            form.find('button[type="submit"]').prop('disabled', false);
        },
        error: function (xhr, status, error) {
            // enable submission
            form.find('button[type="submit"]').prop('disabled', false);

            console.log(error);
            $('#subscribeSparkModal' + guid).append('<p class="p__message">Error subscribing. Please try again later.</p>');
        }
    });
});

export { sparkArticle };